var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaySolid = function SvgPlaySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3845 7.29454C12.0269 5.94735 8.79254 7.05466 8.3813 10.0444C7.87295 13.7401 7.87289 18.2595 8.38119 21.9553C8.79237 24.945 12.0268 26.0523 14.3844 24.7051L22.9332 19.8201C25.8892 18.1309 25.8892 13.8687 22.9332 12.1795L14.3845 7.29454Z",
    fill: "currentColor"
  })));
};
export default SvgPlaySolid;